import {TheBorder} from "../../TheBorder";
import {TheBorderNormalBetPresentation} from "../TheBorderNormalBetPresentation";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderFreeSpinBetPresentation extends TheBorderNormalBetPresentation {
    protected setWinMultiplier(): void {
        if (TheBorder.model.data.nextMode === TheBorderGameMode.FREESPIN) {
            TheBorder.winMultiplierView.setWinMultiplier(1);
        }
    }
}